import { css } from 'lit';

export const drawerStyles = css`
  :host { display: block; }

  .akam-drawer { position: fixed; inset: 0; pointer-events: none; z-index: 1000; }
  .akam-drawer__backdrop { position: absolute; inset:0; background: var(--token-alias-background-overlay, rgba(35,35,38,0.24)); opacity:0; transition: opacity .22s ease; pointer-events:none; z-index:1000; }
  .akam-drawer:not(.enable-transitions) .akam-drawer__backdrop { transition: none !important; }
  .akam-drawer__backdrop.is-open { opacity:1; pointer-events:auto; }

  /* Panel with proper positioning inheritance */
  .akam-drawer__panel { 
    position:absolute; 
    background: var(--token-component-drawer-background, light-dark(#ffffff, #3d3d42)); 
    pointer-events:auto; 
    display:flex; 
    flex-direction:column; 
    transform: translateX(100%); 
    transition: transform 250ms ease-in, opacity .18s ease; 
    will-change: transform; 
    min-width:300px; 
    height:100vh; 
    overflow:hidden; 
    z-index:1001; 
  }
  .akam-drawer.is-open .akam-drawer__panel { transition: transform 300ms ease-out, opacity .18s ease; }
  .akam-drawer:not(.enable-transitions) .akam-drawer__panel { transition:none !important; }

  /* Content container - scrollable area that takes remaining space */
  .akam-drawer__content { 
    display:flex; 
    flex-direction:column; 
    padding: var(--token-global-spacing-s24,24px); 
    gap: var(--token-global-spacing-s24,24px); 
    flex:0 1 auto; /* Takes all available space minus footer */
    overflow:auto; /* This container scrolls when content overflows */
    min-height:0; /* Important for flex scrolling */
  }

  /* positions */
  .position-right { right:0; top:0; height:100%; transform: translateX(100%); }
  .akam-drawer.is-open .position-right { transform: translateX(0); box-shadow: var(--token-alias-elevation-drawer-right, -16px 0 32px 0 rgba(61,61,66,0.18)); }
  .position-left { left:0; top:0; height:100%; transform: translateX(-100%); }
  .akam-drawer.is-open .position-left { transform: translateX(0); box-shadow: var(--token-alias-elevation-drawer-left, 16px 0 32px 0 rgba(61,61,66,0.18)); }
  .position-top { left:0; top:0; width:100%; transform: translateY(-100%); border-radius: 0; }
  .akam-drawer.is-open .position-top { transform: translateY(0); box-shadow: var(--token-alias-elevation-drawer-top, 0 16px 32px 0 rgba(61,61,66,0.18)); }
  .position-bottom { left:0; bottom:0; width:100%; transform: translateY(100%); border-radius: 0; }
  .akam-drawer.is-open .position-bottom { transform: translateY(0); box-shadow: var(--token-alias-elevation-drawer-bottom, 0 -16px 32px 0 rgba(61,61,66,0.18)); }

  /* variants */
  .variant-basic.position-right, .variant-basic.position-left { width:480px; }
  .variant-small.position-right, .variant-small.position-left { width:300px; }
  .variant-flexible.position-right, .variant-flexible.position-left { min-width:300px; max-width:90vw; }
  .variant-basic.position-top, .variant-basic.position-bottom { height:480px; }
  .variant-small.position-top, .variant-small.position-bottom { height:300px; }
  .variant-flexible.position-top, .variant-flexible.position-bottom { min-height:300px; max-height:90vh; }

  /* header/body/footer with proper spacing and typography */
  .akam-drawer__header { 
    display:flex; 
    align-items:flex-start; 
    gap:16px; 
    justify-content:space-between; 
    flex:0 0 auto; 
    color: var(--token-component-drawer-text, light-dark(#343438, #ffffff)); 
    font-family: var(--token-font-family-brand,'Nunito Sans'); 
    font-size: var(--token-font-size-m,18px); 
    font-style: normal;
    font-weight: var(--token-font-weight-bold,700); 
    line-height: var(--token-font-line-height-s,24px); 
  }
  .akam-drawer__body { 
    display:flex; 
    flex-direction:column; 
    /* Stretch children to full width so consumers don't need width:100% */
    align-items:stretch; 
    gap:10px; 
    flex:0 1 auto; 
    align-self:stretch; 
    /* No overflow on body - parent content container handles scrolling */
  }
  .akam-drawer__footer { 
    display:flex; 
    justify-content:flex-end; 
    align-items:flex-start; 
    gap:12px; 
    padding: var(--token-global-spacing-s16,16px) var(--token-global-spacing-s24,24px); 
    border-top:1px solid var(--token-alias-border-normal, light-dark(#d6d6dd, #515157)); 
    background: var(--token-component-drawer-background, light-dark(#ffffff, #3d3d42)); 
    /* Footer should always be visible at the bottom */
    flex:0 0 auto; 
    align-self:stretch; 
  }
  /* Hide footer when marked as empty */
  .akam-drawer__footer.is-empty { display:none; }
  .akam-drawer__footer ::slotted([slot='footer']) { display:flex; justify-content:flex-end; gap:12px; width:100%; }
  .akam-drawer__close { 
    background:none; 
    border:0; 
    cursor:pointer; 
    width:20px; 
    height:20px; 
    color: var(--token-component-drawer-icon-default, light-dark(#3d3d42, #ffffff)); 
    padding:0; 
    display:flex; 
    align-items:center; 
    justify-content:center; 
  }
  .akam-drawer__close:hover { opacity:0.8; }
  .akam-drawer__close svg { width:20px; height:20px; }
`
